
import { RefreshCw } from "lucide-react";

interface OrdersTableEmptyStatesProps {
  isConnected: boolean;
  hasOrders: boolean;
  isFetchingOrders: boolean;
}

const OrdersTableEmptyStates = ({ isConnected, hasOrders, isFetchingOrders }: OrdersTableEmptyStatesProps) => {
  if (!isConnected) {
    return (
      <div className="text-center py-8 text-gray-500">
        Connect your Etsy shop to import and view your orders.
      </div>
    );
  }

  if (isConnected && !hasOrders && !isFetchingOrders) {
    return (
      <div className="text-center py-8 text-gray-500">
        No orders found matching your search criteria.
      </div>
    );
  }

  if (isFetchingOrders) {
    return (
      <div className="text-center py-8 text-gray-500">
        <div className="flex items-center justify-center gap-2">
          <RefreshCw className="h-4 w-4 animate-spin" />
          Loading orders from Etsy...
        </div>
      </div>
    );
  }

  return null;
};

export default OrdersTableEmptyStates;
